export default __webpack_public_path__ + "static/belgorod-cb17b2e0feeb1339fed412761eb61196.jpg";